import { useEffect } from 'react'
import { useRouter } from 'next/router'

// этот хук проверяет используется ли Telegram Web App

export const useBlockTelegram = () => {
	const router = useRouter()

	useEffect(() => {
		if (typeof window === 'undefined') return

		try {
			if (
				typeof window !== 'undefined' &&
				'Telegram' in window &&
				(window as any).Telegram?.WebApp &&
				router.pathname !== '/telegram-blocked'
			) {
				router.replace('/telegram-blocked')
			} else {
			}
		} catch (err) {
			console.error('Ошибка при проверке WebApp:', err)
		}
	}, [router])
}
